import React, { useEffect, useState } from 'react';
import { WifiSlash, ArrowClockwise } from '@phosphor-icons/react';

/**
 * OfflineBanner — globally-mounted thin top banner that appears whenever
 * the browser reports itself offline. Auto-dismisses when network returns.
 * Also listens to explicit reload clicks so the producer can re-try their
 * last view once WiFi comes back.
 */
export const OfflineBanner = () => {
  const [online, setOnline] = useState(typeof navigator === 'undefined' ? true : navigator.onLine);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (online) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] bg-[#FF9500] text-black px-4 py-2 flex items-center justify-center gap-2 text-xs font-bold shadow-md"
      data-testid="offline-banner"
      role="status"
    >
      <WifiSlash size={14} weight="bold" />
      <span>You&apos;re offline — showing last-synced data.</span>
      <button
        onClick={() => window.location.reload()}
        className="ml-2 inline-flex items-center gap-1 px-2 py-0.5 bg-black/10 rounded hover:bg-black/20 transition-colors"
        data-testid="offline-banner-retry"
      >
        <ArrowClockwise size={11} weight="bold" /> Retry
      </button>
    </div>
  );
};
